<template>
  <article class="tablet:flex tablet:gap-x-8 desktop:gap-x-12 wide:gap-x-16">
    <div class="basis-1/2 shrink-0 tablet:flex tablet:flex-col justify-between">
      <header class="mb-4 tablet:pt-3">
        <h2 class="section-title text-secondary mb-2">
          {{ item.title }}
        </h2>
        <h3
                v-if="item?.meta?.category"
                class="article-title text-tertiary">
          {{ item.meta.category }}
        </h3>
      </header>
      <ContentRenderer :value="item" class="with-free-text mb-6"/>
      <ProjectTestimonial
              v-if="item?.meta?.key"
              :item-key="item.meta.key as string"
              class="mb-6"
      />
      <aside class="mt-auto">
        <ProjectBadge
                :item-meta="item.meta as ProjectMeta"
                class="flex flex-nowrap gap-x-4 mb-6 tablet:mb-0"
        />
      </aside>
    </div>
    <SwiperImages
            :items="images"
            class="mb-2 tablet:mb-0 self-start"
            img-class="absolute t-0 l-0 w-full h-full max-w-none max-h-none object-cover"
            picture-class="block min-h-[300px] h-full relative overflow-hidden rounded-img bg-white/77"
    />
  </article>
</template>

<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";
import ProjectBadge from "~/components/project/ProjectBadge.vue";
import type {ProjectMeta} from "~/types/Project/ProjectMeta.interface";
import ProjectTestimonial from "~/components/project/ProjectTestimonial.vue";

const {getPagePath} = useI18nCollection();
const {item} = defineProps<{
    item: PageCollectionItemBase
}>();
const {data: images} = await useFetch('/api/getAssetImages', {
    query: {
        slug: getPagePath(item.path),
        withSize: 'y'
    },
    default: () => []
});
</script>
